<template>
	<div v-if="user" class="avatar-container">
		<img
			v-if="user.avatar && hasValidImage"
			class="rounded-circle"
			:src="user.avatar ? storageUrl + user.avatar : defaultAvatar"
			:alt="user.name"
			:width="size || 32"
			:height="size || 32"
			:title="user.name"
			@error="onImageError"
		/>
		<div
			v-else
			class="avatar-initials rounded-circle"
			:style="{
				width: (size || 32) + 'px',
				height: (size || 32) + 'px',
				fontSize: getFontSize + 'px',
			}"
			:title="user.name"
		>
			{{ getInitials }}
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import store from '../../store/index'
export default {
	name: 'Avatar',
	props: ['user', 'size'],
	data() {
		return {
			defaultAvatar: '',
			imageError: false,
		}
	},
	created() {
		this.defaultAvatar = store.state.avatarUrl
	},
	computed: {
		...mapState(['storageUrl']),
		hasValidImage() {
			return !this.imageError && (this.user.avatar || this.defaultAvatar)
		},
		getInitials() {
			if (!this.user.name) return '?'

			const names = this.user.name.trim().split(' ')
			if (names.length >= 2) {
				// First name + Last name initials
				return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase()
			} else {
				// Single name, use first two letters
				return this.user.name.substring(0, 2).toUpperCase()
			}
		},
		getFontSize() {
			const avatarSize = this.size || 32
			// Font size should be roughly 40% of avatar size
			return Math.max(10, Math.round(avatarSize * 0.4))
		},
	},
	methods: {
		onImageError() {
			this.imageError = true
		},
	},
}
</script>

<style scoped>
.avatar-container {
	display: inline-block;
}

.avatar-initials {
	background-color: #e5e7eb;
	color: #374151;
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: 600;
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
	user-select: none;
	cursor: default;
	flex-shrink: 0;
	border: 2px solid #f3f4f6;
	border-radius: 50% !important;
	line-height: 1;
}

img.rounded-circle {
	flex-shrink: 0;
	border: 2px solid #f3f4f6;
}
</style>
